module.exports = __webpack_public_path__ + "img/brain.6097b581.png";